import React, { Component } from 'react'
import axios from 'axios'
import Helmet from 'react-helmet'
import _ from 'lodash'
import { backendURL } from '../../data/config.json'

//Components
import NotPublished from '../../components/NotPublishedLocation'
import Gmaps from '../../components/Gmaps'
import MainForm from '../../components/MainForm'


class NejapaEs extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
    }
  }
  componentDidMount() {
    axios
      .get(
        `${backendURL}/api/locations/5de6784fe665d00e9936cd02`
      )
      .then(res => {
        const { data } = res
        console.log(data)
        this.setState({
          loading: false,
          ...data,
        })
        axios
        .get(`${backendURL}/api/banners/page/Locations`)
        .then(res => {
          const main = res.data.filter(data => data.section === 'Main')

          this.setState(prevState => {
            return {
              ...prevState,
              loading: false,
              mainImageEs: {
                title: main[0].title,
                url: main[0].imageEs,
              },
            }
          })
        })
        .catch(err => {
          console.log(err)
        })
      })
  }
  renderImgs() {
    const { images, title, lang } = this.state
    if (!_.isEmpty(images)) {
      return _.map(images, img => {
        return (
          <img 
            key={title.es}
            src={`${backendURL}${img}`}
            alt={title.es}
          />
        )
      })
    }
    return null
  }
  render() {
    const { langKey: lang } = this.props.pathContext
    const { title, address, schedule, type, phone, waze } = this.state
    if (this.state.loading) {
      return null
    }
    return (
      <div className="page locations">
        <Helmet
          title={`Car Rental at Nejapa | Budget Nicaragua`}
          meta={[
            {
              name: 'description',
              content:
                'Frequently Asked Questions about car rentals. Contact Us',
            },
          ]}
          link={[
            {
              rel: 'alternate',
              hreflang: { lang },
              href: './en/locations/nejapa/',
            },
          ]}
        >
        <script type="application/ld+json">
            {`{
              '@context': 'http://schema.org',
              '@type': 'LocalBusiness',
              'image':
                'https://backend.budgetcentralamerica.com:5000/uploads/locations1534643033733.jpg',
              'address': {
                '@type': 'PostalAddress',
                'addressLocality': 'Nicaragua',
                'addressRegion': 'Managua',
                'streetAddress': 'Pista Juan Pablo II, Frente A Enel Central',
                'addressCountry': 'Nicaragua',
              },
              'description':
                'Budget Nicaragua, The Best Choice for Truck and Car Rental',
              'name': 'Budget Nicaragua, Aeropuerto Internacional La Aurora',
              'telephone': '+505 2255-9000',
              'openingHoursSpecification': [
                {
                  '@type': 'OpeningHoursSpecification',
                  'dayOfWeek': [
                    'Monday',
                    'Tuesday',
                    'Wednesday',
                    'Thursday',
                    'Friday',
                  ],
                  'opens': '07:00',
                  'closes': '21:00',
                },

                {
                  '@type': 'OpeningHoursSpecification',
                  'dayOfWeek': ['Saturday, Sunday'],
                  'opens': '07:00',
                  'closes': '21:00',
                },
              ],
              'geo': {
                '@type': 'GeoCoordinates',
                'latitude': '12.124089393607338',
                'longitude': '-86.27537727355957',
              },
              'sameAs': [
                'https://www.facebook.com/BudgetNicaragua,
                
              ],
            }`}
          </script>
          </Helmet>
          
          <MainForm
          image={this.state.mainImageEs}
          pickupLocation={7}
          lang={lang}
        />
        <div className="grid-wrapper">
          <div className="sidebar">
            <div className="details">
              <div className={`item title ${type}`}>
                <span className="icon" />
                <h1>{title[lang]}</h1>
              </div>
              <div className="item address">
                <span className="icon" />
                <div>{address[lang]}</div>
              </div>
              <div className="item phone">
                <span className="icon" />
                <div>
                <ul style={{overflow:'auto'}} >{_.map(phone, (item, i) => {

                    let string_item = item.toString()

                    let string_sin_espacio = string_item.replace(/\s/g, "")
                    let string_phone = string_sin_espacio.replace('-', "")

                        return(
                        <li key={i} style={{whiteSpace: 'nowrap'}}>
                        <a href={`tel:${string_phone}`} >
                        {item}
                        </a>
                        </li>)

                    })}

                    </ul>
                </div>
              </div>
              <div className="item schedule">
                <span className="icon" />
                <div>{schedule[lang]}</div>
              </div>
              <div className="item waze">
                <span className="icon" />
                <div>
                  <a href={waze} target="_blank" >View on Waze</a>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="block gmap">
              <Gmaps
                lat={this.state.geolocation[0]}
                lng={this.state.geolocation[1]}
              />
            </div>
            <div className="gallery">{this.renderImgs()}</div>
          </div>
        </div>
      </div>
    )
  }
}
export const query = graphql`
  query NejapaEsQuery {
    imageSharp(id: { regex: "/locations-top-background/" }) {
      sizes(maxWidth: 1600) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`

export default NejapaEs


// WEBPACK FOOTER //
// ./src/pages/locations/nejapa.es.js